import { render, staticRenderFns } from "./SnackEncuesta.vue?vue&type=template&id=1df66e7a&"
import script from "./SnackEncuesta.vue?vue&type=script&lang=ts&"
export * from "./SnackEncuesta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports